<template>
  <div
      class="ts-ranking d-flex align-center"
  >
    <v-tabs
        v-model="activeRecordTypeIdx"
        class="ts-ranking__tabs"
        centered
        center-active
    >
      <v-tab v-for="(recordType,i) in recordTypes" :key="i">{{recordType.title}}</v-tab>
    </v-tabs>
    <ts-circle-loader :value="loading" absolute></ts-circle-loader>
    <ts-ranking-card
        ref="rankingCard"
        :players="players"
        :records="records"
        :title="recordTypes[activeRecordTypeIdx].title"
        :record-filter="recordTypes[activeRecordTypeIdx].recordFilter"
        :team="recordTypes[activeRecordTypeIdx].team"
        :min-total="1"
        @calculated="(data) => handleCalculated(activeRecordTypeIdx,data)"
        @click="handleClickRankingCard"
    ></ts-ranking-card>
  </div>
</template>

<style lang="scss">
  .ts-ranking{
    position:relative;
    height: 450px;
    flex-direction: column;
    margin: 10px 0;

    .ts-ranking__tabs{
      flex-grow:0;
      width: 400px;
    }

    .v-slide-group__prev, .v-slide-group__next{
      z-index:1;
      position:absolute;top:0; height:100%;left:0;
      width:100px;
      user-select: none; cursor:initial !important;
      background: linear-gradient(90deg, rgba(230,230,230,1) 0%, rgba(255,255,255,0) 100%);
      > i {cursor:pointer;}
    }
    .v-slide-group__next{
      right:0;left:initial;
      background: linear-gradient(270deg, rgba(230,230,230,1) 0%, rgba(255,255,255,0) 100%);
    }
    .v-slide-group{
      &__content{
        padding: 10px 0;
      }
    }
    .ts-ranking-card{
      flex-grow:1;
      height:0;
      width: 400px;
      max-width: 100%;
    }
  }
</style>

<script>
  import TsRankingCard from "./TsRankingCard";
  import TsCircleLoader from "@/components/common/TsCircleLoader";

  export default {
    name: "TsRanking",
    components: {TsCircleLoader, TsRankingCard},
    props: {
      players: Array,
      records: Array,
    },
    data () {
      return {
        loading: false,
        activeRecordTypeIdx: 0,
        recordTypes: [
          {
            key: "jonghab",
            title: '복단종합',
            recordFilter: () => true,
            calculatedData: null,
          },
          {
            key: "boksik_e",
            title: '복식개인',
            calculatedData: null,
          },
          {
            key: "dansik",
            title: '단식랭킹',
            recordFilter: record => !record.boksik,
            calculatedData: null,
          },
          {
            key: "boksik",
            title: '복식랭킹',
            team: true,
            calculatedData: null,
          },
        ]
      }
    },
    watch: {
      records:{
        deep:true,
        handler(){
          this.recordTypes.forEach(recordType => (recordType.calculatedData = null))
          this.$forceUpdate()
        }
      }
    },
    methods: {
      handleCalculated(i,data){
        this.recordTypes[i].calculatedData = data
        if(i === this.activeRecordTypeIdx)
          this.handleClickRankingCard(data)
      },
      handleClickRankingCard(data){
        this.$emit('click:ranking-card', data)
      }
    }
  }
</script>
